import React, { useRef, useState, useEffect } from "react"
import { useTranslation } from 'react-i18next';
import _ from 'lodash';

import { RowContainer, LabelTitle } from "./LabelTitle"
// import { Slider } from "../ui/slider"
import { Switch } from "../ui/switch"

// import * as SliderPrimitive from "@radix-ui/react-slider"

// import DiffusionOptionsDescEta from "./DiffusionOptionsDesc/DiffusionOptionsDescEta";
import StyleChangeDescIpaAll from "./StyleChangeDesc/StyleChangeDescIpaAll";

import { useHookStore } from "../../hook-store/store"
// import { resizeImageFile } from '../../utils/image/image-utils';
import { marks } from '../../utils/marks';

import "./DiffusionOptionsImagePrompt.css";


function StyleChangeUseIpaAll() {
    
    const [t] = useTranslation('translation');
  
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [hStore, hDispatch] = useHookStore();
    const { 
      useIpaAll,
    } = (hStore as any).iopaintStore;

    const [showEtaDesc, setShowEtaDesc] = useState(false);

    const changeStyleChangeGuidanceHandler = (val: any) => {
      if (val >= 2 && val <= 8) {
        (hDispatch as any)('SET_STYLECHANGEGUIDANCE', val);
      }
    }

    return (
      <div 
      // className="flex flex-col gap-1"
      >
        <div>
          <LabelTitle
            htmlFor="style-change-use-ipa-all"
            text="Style Change Add Shape"
            // toolTip="The number of denoising steps. More denoising steps usually lead to a higher quality image at the expense of slower inference."
            toolTip={`style-change-useipaall`}
          />

          <span
            onClick={() => {
              setShowEtaDesc(!showEtaDesc);
            }}
          >
            {' '}{marks.questionCircleOMark}
          </span>
        </div>
        <RowContainer>
            <Switch
                style={{ border: "1px solid gray" }}
                id="seed"
                checked={useIpaAll}
                onCheckedChange={(value) => {
                    (hDispatch as any)('SET_USEIPAALL', value);
                    // updateSettings({ seedFixed: value })
                }}
            />

          <div>{useIpaAll && 'Add Shape'}</div>
        </RowContainer>

        {showEtaDesc && (
          <StyleChangeDescIpaAll />
        )}
      </div>
    )
  }


export default StyleChangeUseIpaAll